export default __webpack_public_path__ + "static/media/chart1.5c4e0242.svg";